/* plush-quiz.js – v11  Google Sheets Integration - 沙盒环境兼容版 */
document.addEventListener('DOMContentLoaded', () => {
  /* 环境检测和初始化 */
  const ENVIRONMENT = detectEnvironment();
  console.log('🔍 环境检测结果:', ENVIRONMENT);
  
  /* Google Sheets 配置 */
  const GOOGLE_SHEETS_CONFIG = {
    // 🚨 重要：请替换为你的真实 Google Apps Script Web App URL
    // 从 Google Apps Script -> 部署 -> 管理部署 中获取
    webAppUrl: 'https://script.google.com/macros/s/AKfycbxLn5EwFndbkek9NCQGhpL1pQtbB6xsmHTxvoQ3qyZ0nozrCkrkW1JfvbDEZY2OKP1B/exec',
    // 重试配置
    maxRetries: 3,
    retryDelay: 1000,
    // 请求超时设置
    timeout: 10000
  };

  // 🔍 调试：检查配置状态
  console.log('Google Sheets 配置状态:', {
    hasUrl: !!GOOGLE_SHEETS_CONFIG.webAppUrl && GOOGLE_SHEETS_CONFIG.webAppUrl !== 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE',
    url: GOOGLE_SHEETS_CONFIG.webAppUrl,
    environment: ENVIRONMENT.type
  });

  /* 环境检测函数 */
  function detectEnvironment() {
    const env = {
      type: 'unknown',
      features: {
        localStorage: false,
        sessionStorage: false,
        indexedDB: false,
        cookies: false,
        fetch: false,
        sandboxed: false
      },
      limitations: []
    };
    
    // 检测基本功能
    try {
      env.features.fetch = typeof fetch !== 'undefined';
    } catch (e) {
      env.limitations.push('fetch API 不可用');
    }
    
    // 检测存储功能
    try {
      if (typeof Storage !== 'undefined') {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        env.features.localStorage = true;
      }
    } catch (e) {
      env.limitations.push('localStorage 被阻止: ' + e.message);
      if (e.message.includes('sandboxed')) {
        env.features.sandboxed = true;
      }
    }
    
    try {
      if (typeof Storage !== 'undefined') {
        sessionStorage.setItem('test', 'test');
        sessionStorage.removeItem('test');
        env.features.sessionStorage = true;
      }
    } catch (e) {
      env.limitations.push('sessionStorage 被阻止: ' + e.message);
    }
    
    try {
      env.features.indexedDB = !!window.indexedDB;
    } catch (e) {
      env.limitations.push('IndexedDB 不可用');
    }
    
    try {
      document.cookie = 'test=test; path=/';
      env.features.cookies = document.cookie.includes('test=test');
      // 清理测试 cookie
      document.cookie = 'test=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    } catch (e) {
      env.limitations.push('Cookies 被阻止');
    }
    
    // 确定环境类型
    if (env.features.sandboxed) {
      env.type = 'sandboxed';
    } else if (window.location.protocol === 'file:') {
      env.type = 'local';
    } else if (window.location.hostname.includes('shopify')) {
      env.type = 'shopify';
    } else if (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1')) {
      env.type = 'development';
    } else {
      env.type = 'production';
    }
    
    return env;
  }

  /* =======  问答逻辑，与之前相同，只改提交部分  ======= */
  document.querySelectorAll('.plush-quiz-placeholder').forEach(holder => {
    if (holder.dataset.rendered) return;
    holder.dataset.rendered = '1';

    /* —— 如刷新回显 —— */
    const cache = sessionStorage.getItem('plushQuizResult');
    if (cache) {
      const p = JSON.parse(cache);
      holder.innerHTML = `
        <div class="pq-card pq-result">
          <h3 class="pq-title">🎉 Your Plushie Match</h3>
          <a href="/products/${p.handle}">
            <img src="${p.image}" width="220" style="border-radius:12px">
            <div class="pq-prod-title">${p.title}</div>
          </a>
        </div>`;
      sessionStorage.removeItem('plushQuizResult');
      return;
    }

    /* —— 读取题目 & 产品 —— */
    const products = (holder.dataset.products || '')
      .split(',').map(s => s.trim()).filter(Boolean);
    const q = [1,2,3,4,5].map(i => ({
      text : holder.dataset[`q${i}`]  || `Question ${i}`,
      opts : (holder.dataset[`q${i}Opts`] || '').split('|').map(o=>o.trim()).filter(Boolean)
    }));

    /* —— 注入 UI —— */
    holder.innerHTML = `
      <div class="pq-card pq-center">
        <h2 class="pq-title">What Plushie Matches You?</h2>
        <p>Ready to discover your perfect companion? Take our quick quiz!</p>
        <button class="pq-btn pq-start">Start Quiz Now</button>
      </div>

      <div class="pq-card pq-quiz"  style="display:none;">
        <div class="pq-progress"><span style="width:0"></span></div>
        <h3 class="pq-question"></h3>
        <div class="pq-options"></div>
      </div>

      <div class="pq-card pq-email" style="display:none;">
        <h3>Almost there!</h3>
        <p>Enter your email to see your plushie match 👇</p>
        <input type="email" placeholder="you@example.com" required>
        <button class="pq-btn pq-submit">Show my match</button>
      </div>
    `;

    const startCard = holder.querySelector('.pq-center');
    const quizCard  = holder.querySelector('.pq-quiz');
    const emailCard = holder.querySelector('.pq-email');
    const progress  = quizCard.querySelector('.pq-progress span');
    const qTitle    = quizCard.querySelector('.pq-question');
    const qOptsBox  = quizCard.querySelector('.pq-options');

    /* —— 测题 —— */
    let step = 0;
    const renderQ = () => {
      const cur = q[step];
      qTitle.textContent   = cur.text;
      progress.style.width = (step / q.length * 100) + '%';
      qOptsBox.innerHTML   = cur.opts.map(opt=>`<button class="pq-opt">${opt}</button>`).join('');
      qOptsBox.querySelectorAll('.pq-opt').forEach(btn=>{
        btn.onclick = () => {
          step++;
          if (step < q.length) renderQ();
          else { quizCard.style.display='none'; emailCard.style.display='block'; }
        };
      });
    };
    holder.querySelector('.pq-start').onclick = () => {
      startCard.style.display='none';
      quizCard.style.display ='block';
      renderQ();
    };

    /* —— 提交邮箱到 Google Sheets —— */
    emailCard.querySelector('.pq-submit').onclick = async () => {
      const email = emailCard.querySelector('input').value.trim();
      if (!email) { alert('Please enter email'); return; }

      // 邮箱验证
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert('请输入有效的邮箱地址');
        return;
      }

      /* 随机产品 -> sessionStorage */
      const handle = products[Math.floor(Math.random()*products.length)];
      const prod   = await fetch(`/products/${handle}.js`).then(r=>r.json());
      const quizResult = prod.title; // 保存测试结果
      
      sessionStorage.setItem('plushQuizResult', JSON.stringify({
        handle: prod.handle, title: prod.title, image: prod.featured_image
      }));

      /* 提交到 Google Sheets */
      const submitBtn = emailCard.querySelector('.pq-submit');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Submitting...';
      submitBtn.disabled = true;
      
      console.log('提交邮箱到 Google Sheets...');
      
      try {
        const success = await submitToGoogleSheets(email, quizResult);
        
        if (success) {
          console.log('邮箱提交成功');
          submitBtn.textContent = 'Success!';
          
          // 显示成功消息
          alert('感谢您的参与！邮箱已成功提交。');
          
          setTimeout(() => {
            location.reload();
          }, 1500);
          return;
        }
        
        // 备用方案：本地存储
        console.log('使用备用存储方案');
        await fallbackEmailStorage(email, quizResult);
        
        submitBtn.textContent = 'Saved!';
        alert('邮箱已保存，我们会尽快联系您！');
        
        setTimeout(() => {
          location.reload();
        }, 1500);
        
      } catch (error) {
        console.error('邮箱提交失败:', error);
        
        // 恢复按钮状态
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        
        alert('提交失败，请稍后重试或联系客服');
      }
    };
    
    // 提交到 Google Sheets（使用多种方法避免 CORS）
    async function submitToGoogleSheets(email, quizResult, retryCount = 0) {
      try {
        // 检查配置
        if (!GOOGLE_SHEETS_CONFIG.webAppUrl || GOOGLE_SHEETS_CONFIG.webAppUrl === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE') {
          console.warn('❌ Google Sheets Web App URL 未配置，使用备用方案');
          console.log('💡 请在 plush-quiz.js 中设置正确的 webAppUrl');
          return false;
        }
        
        console.log('🚀 开始提交到 Google Sheets...');
        console.log('📍 URL:', GOOGLE_SHEETS_CONFIG.webAppUrl);
        
        // 准备提交数据
        const submitData = {
          email: email,
          quizResult: quizResult,
          source: 'Plush Quiz',
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent.substring(0, 100), // 限制长度
          referrer: (document.referrer || 'direct').substring(0, 100) // 限制长度
        };
        
        console.log('📦 提交数据:', submitData);
        
        // 方法1: 尝试使用 JSONP 方式（最兼容）
        console.log('🔄 尝试方法1: JSONP 提交...');
        const jsonpResult = await submitViaJSONP(submitData);
        if (jsonpResult) {
          console.log('✅ JSONP 提交成功！');
          await fallbackEmailStorage(email, quizResult, 'google-sheets-backup');
          return true;
        }
        
        // 方法2: 尝试使用隐藏表单提交
        console.log('🔄 尝试方法2: 表单提交...');
        const formResult = await submitViaForm(submitData);
        if (formResult) {
          console.log('✅ 表单提交成功！');
          await fallbackEmailStorage(email, quizResult, 'google-sheets-backup');
          return true;
        }
        
        // 方法3: 尝试使用 fetch（作为最后手段）
        console.log('🔄 尝试方法3: Fetch 提交...');
        const fetchResult = await submitViaFetch(submitData);
        if (fetchResult) {
          console.log('✅ Fetch 提交成功！');
          await fallbackEmailStorage(email, quizResult, 'google-sheets-backup');
          return true;
        }
        
        throw new Error('所有提交方法都失败');
        
      } catch (error) {
        console.error(`❌ Google Sheets 提交失败 (尝试 ${retryCount + 1}/${GOOGLE_SHEETS_CONFIG.maxRetries}):`, error);
        
        // 重试逻辑
        if (retryCount < GOOGLE_SHEETS_CONFIG.maxRetries - 1) {
          const delay = GOOGLE_SHEETS_CONFIG.retryDelay * Math.pow(2, retryCount); // 指数退避
          console.log(`⏳ 等待 ${delay}ms 后重试...`);
          await new Promise(resolve => setTimeout(resolve, delay));
          return await submitToGoogleSheets(email, quizResult, retryCount + 1);
        }
        
        console.error('💥 所有重试都失败了，使用备用方案');
        return false;
      }
    }
    
    // JSONP 提交方法（最兼容 CORS，专门优化 Shopify 环境）
    function submitViaJSONP(data) {
      return new Promise((resolve) => {
        try {
          // 生成唯一的回调函数名（避免冲突）
          const timestamp = Date.now();
          const random = Math.floor(Math.random() * 10000);
          const callbackName = `plushQuizCallback_${timestamp}_${random}`;
          
          console.log('🔄 JSONP 提交开始，回调函数:', callbackName);
          
          // 准备 URL 参数
          const params = new URLSearchParams();
          Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined) {
              params.append(key, String(data[key]));
            }
          });
          params.append('callback', callbackName);
          
          const requestUrl = `${GOOGLE_SHEETS_CONFIG.webAppUrl}?${params.toString()}`;
          console.log('📍 JSONP 请求 URL:', requestUrl.substring(0, 200) + '...');
          
          // 创建全局回调函数
          window[callbackName] = function(response) {
            console.log('📡 JSONP 响应接收:', response);
            
            // 立即清理
            cleanup();
            
            // 验证响应
            if (response && typeof response === 'object') {
              if (response.success === true) {
                console.log('✅ JSONP 提交成功');
                resolve(true);
              } else {
                console.warn('⚠️ JSONP 响应显示失败:', response.error || '未知错误');
                resolve(false);
              }
            } else {
              console.warn('⚠️ JSONP 响应格式异常:', response);
              resolve(false);
            }
          };
          
          // 创建 script 标签
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.defer = true;
          
          // 错误处理
          script.onerror = function(error) {
            console.error('❌ JSONP 脚本加载失败:', error);
            cleanup();
            resolve(false);
          };
          
          // 加载完成处理
          script.onload = function() {
            console.log('📜 JSONP 脚本加载完成');
            // 注意：onload 不代表回调已执行，回调执行在 window[callbackName] 中处理
          };
          
          // 清理函数
          function cleanup() {
            try {
              // 移除 script 标签
              if (script && script.parentNode) {
                script.parentNode.removeChild(script);
              }
              
              // 删除全局回调函数
              if (window[callbackName]) {
                delete window[callbackName];
              }
            } catch (cleanupError) {
              console.warn('清理 JSONP 资源时出错:', cleanupError);
            }
          }
          
          // 设置超时（重要：防止无限等待）
          const timeoutId = setTimeout(() => {
            console.warn('⏰ JSONP 请求超时');
            cleanup();
            resolve(false);
          }, GOOGLE_SHEETS_CONFIG.timeout);
          
          // 成功时清除超时
          const originalCallback = window[callbackName];
          window[callbackName] = function(response) {
            clearTimeout(timeoutId);
            originalCallback(response);
          };
          
          // 设置 URL 并添加到页面
          script.src = requestUrl;
          
          // 添加到 head（更可靠）
          const head = document.head || document.getElementsByTagName('head')[0];
          head.appendChild(script);
          
          console.log('📤 JSONP 请求已发送');
          
        } catch (error) {
          console.error('❌ JSONP 方法异常:', error);
          resolve(false);
        }
      });
    }
    
    // 表单提交方法（避免 CORS）
    function submitViaForm(data) {
      return new Promise((resolve) => {
        try {
          // 创建隐藏的 iframe 用于接收响应
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.name = 'plushQuizFrame_' + Date.now();
          document.body.appendChild(iframe);
          
          // 创建表单
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = GOOGLE_SHEETS_CONFIG.webAppUrl;
          form.target = iframe.name;
          form.style.display = 'none';
          
          // 添加表单字段
          Object.keys(data).forEach(key => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
          });
          
          // 监听 iframe 加载
          let resolved = false;
          iframe.onload = function() {
            if (!resolved) {
              resolved = true;
              console.log('📡 表单提交完成');
              cleanup();
              resolve(true); // 假设成功，因为无法读取跨域 iframe 内容
            }
          };
          
          iframe.onerror = function() {
            if (!resolved) {
              resolved = true;
              console.warn('❌ 表单提交失败');
              cleanup();
              resolve(false);
            }
          };
          
          // 清理函数
          function cleanup() {
            setTimeout(() => {
              if (form.parentNode) form.parentNode.removeChild(form);
              if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
            }, 1000);
          }
          
          // 设置超时
          setTimeout(() => {
            if (!resolved) {
              resolved = true;
              console.warn('⏰ 表单提交超时');
              cleanup();
              resolve(false);
            }
          }, GOOGLE_SHEETS_CONFIG.timeout);
          
          // 提交表单
          document.body.appendChild(form);
          form.submit();
          
        } catch (error) {
          console.error('❌ 表单提交方法异常:', error);
          resolve(false);
        }
      });
    }
    
    // Fetch 提交方法（最后手段）
    async function submitViaFetch(data) {
      try {
        console.log('🌐 发送 Fetch 请求...');
        
        // 将数据编码为 URL 参数
        const params = new URLSearchParams(data);
        const requestUrl = `${GOOGLE_SHEETS_CONFIG.webAppUrl}?${params.toString()}`;
        
        console.log('📍 请求 URL:', requestUrl.substring(0, 200) + '...');
        
        // 创建 AbortController 用于超时控制
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), GOOGLE_SHEETS_CONFIG.timeout);
        
        const response = await fetch(requestUrl, {
          method: 'GET',
          mode: 'no-cors', // 使用 no-cors 模式避免 CORS 错误
          signal: controller.signal,
          headers: {
            'Accept': 'application/json, text/plain, */*'
          }
        });
        
        clearTimeout(timeoutId);
        
        console.log('📡 Fetch 响应状态:', response.status, response.type);
        
        // 在 no-cors 模式下，我们无法读取响应内容，但如果没有抛出错误就认为成功
        if (response.type === 'opaque') {
          console.log('✅ No-CORS 请求完成（无法验证结果）');
          return true;
        }
        
        // 如果可以读取响应，尝试解析
        if (response.ok) {
          try {
            const result = await response.json();
            console.log('✅ Fetch 响应:', result);
            return result && result.success;
          } catch (e) {
            console.log('✅ Fetch 请求完成（响应解析失败，但请求成功）');
            return true;
          }
        }
        
        return false;
        
      } catch (error) {
        if (error.name === 'AbortError') {
          console.error('⏰ Fetch 请求超时');
        } else {
          console.error('❌ Fetch 请求失败:', error);
        }
        return false;
      }
    }
    
    // 备用存储函数（沙盒环境兼容版）
    async function fallbackEmailStorage(email, quizResult, source = 'fallback') {
      try {
        console.log('💾 启用备用存储方案...');
        
        const storageData = {
          email: email,
          quizResult: quizResult,
          source: source,
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent.substring(0, 100), // 限制长度
          url: window.location.href.substring(0, 200) // 限制长度
        };
        
        // 检测存储环境并选择最佳方案
        const storageResult = await tryMultipleStorageMethods(storageData);
        
        if (storageResult.success) {
          console.log(`✅ 邮箱已保存到${storageResult.method}`);
          console.log('📦 存储数据:', storageData);
        } else {
          console.warn('⚠️ 所有存储方案都失败，但数据已记录');
        }
        
        // 尝试发送到 Google Analytics
        if (typeof gtag !== 'undefined') {
          try {
            gtag('event', 'quiz_email_submit', {
              'event_category': 'engagement',
              'event_label': quizResult,
              'custom_parameter_email': email,
              'custom_parameter_source': source
            });
          } catch (e) {
            console.warn('Google Analytics 发送失败:', e);
          }
        }
        
        // 尝试发送到 Facebook Pixel
        if (typeof fbq !== 'undefined') {
          try {
            fbq('track', 'Lead', {
              content_name: 'Plush Quiz Email',
              content_category: quizResult,
              value: 1,
              currency: 'USD'
            });
          } catch (e) {
            console.warn('Facebook Pixel 发送失败:', e);
          }
        }
        
        return true;
        
      } catch (error) {
        console.error('❌ 备用存储失败:', error);
        return false;
      }
    }
    
    // 多重存储方案尝试（沙盒环境兼容）
    async function tryMultipleStorageMethods(data) {
      // 根据环境检测结果排序存储方法
      const methods = getStorageMethodsByPriority(ENVIRONMENT);
      
      for (const method of methods) {
        try {
          console.log(`🔄 尝试 ${method.method} 存储...`);
          await method.fn(data);
          console.log(`✅ ${method.method} 存储成功`);
          return { success: true, method: method.method };
        } catch (error) {
          console.warn(`❌ ${method.method} 存储失败:`, error.message);
          continue;
        }
      }
      
      // 如果所有方法都失败，至少记录到控制台
      console.error('📝 所有存储方法都失败，记录到控制台:', data);
      return { success: false, method: '控制台日志' };
    }
    
    // 根据环境获取优先级排序的存储方法
    function getStorageMethodsByPriority(environment) {
      const allMethods = [
        {
          name: 'localStorage',
          method: 'localStorage',
          available: environment.features.localStorage,
          priority: environment.features.localStorage ? 1 : 99,
          fn: (data) => {
            if (!environment.features.localStorage) throw new Error('localStorage not available');
            
            const existing = localStorage.getItem('quiz-subscribers');
            const emails = existing ? JSON.parse(existing) : [];
            
            // 检查是否已存在相同邮箱
            const existingIndex = emails.findIndex(sub => sub.email === data.email);
            if (existingIndex !== -1) {
              emails[existingIndex] = { ...emails[existingIndex], ...data };
            } else {
              emails.push(data);
            }
            
            localStorage.setItem('quiz-subscribers', JSON.stringify(emails));
            return true;
          }
        },
        {
          name: 'sessionStorage', 
          method: 'sessionStorage',
          available: environment.features.sessionStorage,
          priority: environment.features.sessionStorage ? 2 : 99,
          fn: (data) => {
            if (!environment.features.sessionStorage) throw new Error('sessionStorage not available');
            
            const existing = sessionStorage.getItem('quiz-subscribers');
            const emails = existing ? JSON.parse(existing) : [];
            emails.push(data);
            sessionStorage.setItem('quiz-subscribers', JSON.stringify(emails));
            return true;
          }
        },
        {
          name: 'indexedDB',
          method: 'IndexedDB',
          available: environment.features.indexedDB,
          priority: environment.features.indexedDB ? 3 : 99,
          fn: (data) => {
            return new Promise((resolve, reject) => {
              if (!environment.features.indexedDB) {
                reject(new Error('IndexedDB not available'));
                return;
              }
              
              const request = indexedDB.open('PlushQuizDB', 1);
              
              request.onerror = () => reject(request.error);
              
              request.onsuccess = () => {
                const db = request.result;
                const transaction = db.transaction(['emails'], 'readwrite');
                const store = transaction.objectStore('emails');
                store.add({...data, id: Date.now()});
                
                transaction.oncomplete = () => resolve(true);
                transaction.onerror = () => reject(transaction.error);
              };
              
              request.onupgradeneeded = () => {
                const db = request.result;
                if (!db.objectStoreNames.contains('emails')) {
                  db.createObjectStore('emails', { keyPath: 'id' });
                }
              };
            });
          }
        },
        {
          name: 'cookie',
          method: 'Cookie存储',
          available: environment.features.cookies,
          priority: environment.features.cookies ? 4 : 99,
          fn: (data) => {
            if (!environment.features.cookies) throw new Error('Cookies not available');
            
            // 简化数据用于 cookie 存储
            const cookieData = {
              e: data.email,
              q: data.quizResult.substring(0, 50),
              t: Date.now()
            };
            
            const cookieValue = btoa(JSON.stringify(cookieData));
            const cookieName = `pqe_${Date.now()}`;
            
            // 设置 cookie（7天过期）
            const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
            document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=/; SameSite=Lax`;
            
            return true;
          }
        },
        {
          name: 'memory',
          method: '内存存储',
          available: true, // 总是可用
          priority: 5,
          fn: (data) => {
            if (!window.plushQuizEmailBackup) {
              window.plushQuizEmailBackup = [];
            }
            window.plushQuizEmailBackup.push({...data, id: Date.now()});
            return true;
          }
        }
      ];
      
      // 根据优先级和可用性排序
      return allMethods
        .filter(method => method.available)
        .sort((a, b) => a.priority - b.priority);
    }
    
    // 导出邮箱数据功能（调试用）
    window.exportQuizEmails = function() {
      console.log('📊 导出邮箱数据...');
      
      const allData = {
        environment: ENVIRONMENT,
        config: {
          hasValidUrl: !!GOOGLE_SHEETS_CONFIG.webAppUrl && GOOGLE_SHEETS_CONFIG.webAppUrl !== 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE',
          maxRetries: GOOGLE_SHEETS_CONFIG.maxRetries,
          timeout: GOOGLE_SHEETS_CONFIG.timeout
        },
        storage: {
          localStorage: [],
          sessionStorage: [],
          memory: window.plushQuizEmailBackup || [],
          cookies: []
        },
        timestamp: new Date().toISOString()
      };
      
      // 尝试从各种存储中获取数据
      try {
        if (ENVIRONMENT.features.localStorage) {
          const localData = localStorage.getItem('quiz-subscribers');
          allData.storage.localStorage = localData ? JSON.parse(localData) : [];
        }
      } catch (e) {
        console.warn('无法读取 localStorage:', e.message);
      }
      
      try {
        if (ENVIRONMENT.features.sessionStorage) {
          const sessionData = sessionStorage.getItem('quiz-subscribers');
          allData.storage.sessionStorage = sessionData ? JSON.parse(sessionData) : [];
        }
      } catch (e) {
        console.warn('无法读取 sessionStorage:', e.message);
      }
      
      // 读取 cookies
      try {
        if (ENVIRONMENT.features.cookies) {
          const cookies = document.cookie.split(';');
          allData.storage.cookies = cookies
            .filter(cookie => cookie.trim().startsWith('pqe_'))
            .map(cookie => {
              try {
                const [name, value] = cookie.trim().split('=');
                return {
                  name: name,
                  data: JSON.parse(atob(value))
                };
              } catch (e) {
                return { name: cookie.trim(), error: 'Parse failed' };
              }
            });
        }
      } catch (e) {
        console.warn('无法读取 cookies:', e.message);
      }
      
      console.log('📋 完整数据导出:', allData);
      
      // 创建下载链接
      const dataStr = JSON.stringify(allData, null, 2);
      const dataBlob = new Blob([dataStr], {type: 'application/json'});
      const url = URL.createObjectURL(dataBlob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `plush-quiz-data-${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      return allData;
    };
    
    // 环境诊断功能
    window.diagnoseQuizEnvironment = function() {
      console.log('🔍 开始环境诊断...');
      
      const diagnosis = {
        timestamp: new Date().toISOString(),
        environment: ENVIRONMENT,
        tests: {
          googleSheetsUrl: {
            configured: !!GOOGLE_SHEETS_CONFIG.webAppUrl && GOOGLE_SHEETS_CONFIG.webAppUrl !== 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE',
            url: GOOGLE_SHEETS_CONFIG.webAppUrl,
            status: 'unknown'
          },
          storage: {},
          network: {
            fetch: typeof fetch !== 'undefined',
            cors: 'unknown'
          }
        },
        recommendations: []
      };
      
      // 测试存储功能
      const storageTests = [
        { name: 'localStorage', test: () => { localStorage.setItem('test', 'test'); localStorage.removeItem('test'); } },
        { name: 'sessionStorage', test: () => { sessionStorage.setItem('test', 'test'); sessionStorage.removeItem('test'); } },
        { name: 'cookies', test: () => { document.cookie = 'test=test'; document.cookie = 'test=; expires=Thu, 01 Jan 1970 00:00:00 GMT'; } },
        { name: 'indexedDB', test: () => { if (!window.indexedDB) throw new Error('Not supported'); } }
      ];
      
      storageTests.forEach(({ name, test }) => {
        try {
          test();
          diagnosis.tests.storage[name] = { available: true, error: null };
        } catch (error) {
          diagnosis.tests.storage[name] = { available: false, error: error.message };
        }
      });
      
      // 生成建议
      if (!diagnosis.tests.googleSheetsUrl.configured) {
        diagnosis.recommendations.push('配置正确的 Google Apps Script Web App URL');
      }
      
      if (ENVIRONMENT.features.sandboxed) {
        diagnosis.recommendations.push('检测到沙盒环境，某些存储功能可能受限');
      }
      
      if (!diagnosis.tests.storage.localStorage.available && !diagnosis.tests.storage.sessionStorage.available) {
        diagnosis.recommendations.push('所有 Web Storage API 都不可用，将使用内存存储');
      }
      
      if (ENVIRONMENT.limitations.length > 0) {
        diagnosis.recommendations.push('环境限制: ' + ENVIRONMENT.limitations.join(', '));
      }
      
      console.log('🏥 诊断结果:', diagnosis);
      return diagnosis;
    };
    
    // 测试 Google Sheets 连接
    window.testGoogleSheetsConnection = async function() {
      console.log('🧪 测试 Google Sheets 连接...');
      
      if (!GOOGLE_SHEETS_CONFIG.webAppUrl || GOOGLE_SHEETS_CONFIG.webAppUrl === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE') {
        console.error('❌ Google Apps Script URL 未配置');
        return { success: false, error: 'URL not configured' };
      }
      
      try {
        const testData = {
          email: 'test@example.com',
          quizResult: 'Test Product',
          source: 'Connection Test',
          timestamp: new Date().toISOString()
        };
        
        const result = await submitToGoogleSheets(testData.email, testData.quizResult);
        
        if (result) {
          console.log('✅ Google Sheets 连接测试成功');
          return { success: true, data: testData };
        } else {
          console.error('❌ Google Sheets 连接测试失败');
          return { success: false, error: 'Submission failed' };
        }
      } catch (error) {
        console.error('❌ Google Sheets 连接测试出错:', error);
        return { success: false, error: error.message };
      }
    };
    
    // 初始化时运行诊断（仅在开发环境）
    if (ENVIRONMENT.type === 'development' || window.location.search.includes('debug=true')) {
      console.log('🚀 开发模式：运行自动诊断');
      setTimeout(() => {
        window.diagnoseQuizEnvironment();
      }, 1000);
    };
  });
});